import React, { useState } from "react";
import Layout from "../../../../components/Layouts/Layouts/Layout";
import Layout2 from "../../../../components/Layouts/Layouts/Layout2";
import DashboardHeader from "../../../../components/basic/DashboardHeader";
import { Button, Col, Row } from "react-bootstrap";
import NonBindingDispute from "./NonBindingDispute/NonBindingDispute";
import NonBindingDisputeTrack from "./NonBindingDispute/NonBindingDisputeTrack";
import NonBindingCaseSummery from "./NonBindingDispute/NonBindingCaseSummery";
import BindingDispute from "./BindingDispute/BindingDispute";
import BindingDisputeTrack from "./BindingDispute/BindingDisputeTrack";
import QuickLinks from "../../../../components/basic/QuickLinks";
import ArbitratorDisputesPage from "./BindingDispute/ArbitratorDisputesPage"; // Import the ArbitratorDisputesPage component
import { getAuthUserlocal } from "../../../../store/services";
import BindingDisputeDetails from "./BindingDispute/BindingDisputeDetails";

const HomePage = ({ setActivePage }) => (
  <div>
    <div className="mb-4">
      <h5>
        Encountering challenges in your overseas transactions? Submit your dispute
        details below for prompt resolution. Our dedicated team is ready to assist
        you. Please select either a binding or non-binding dispute, and our experts
        will address your query efficiently.
      </h5>
    </div>
    <div className="border p-4">
      <Row className="align-items-end">
        <Col>
          <div className="d-flex flex-column justify-content-end align-items-center">
            <div className="w-75">
              A party that has entered into a contract or agreement, incorporating
              the model clause of AECCI-IAC, is eligible to file a case under the{" "}
              <strong>Binding Dispute</strong> mechanism.
            </div>
            <div className="my-4 fs-6 d-flex flex-column gap-2">
              <Button onClick={() => setActivePage("bindingDispute")}>
                AECCI-IAC BINDING DISPUTE
              </Button>
              <Button onClick={() => setActivePage("trackBindingDispute")}>
                TRACK YOUR DISPUTE
              </Button>
            </div>
          </div>
        </Col>
        <Col>
          <div className="d-flex flex-column justify-content-end align-items-center">
            <div className="w-75 m-auto">
              A party that has not entered into any contract or agreement and has
              chosen not to invoke the model clause of AECCI-IAC may opt for the{" "}
              <strong>Non Binding Dispute</strong> resolution process.
            </div>
            <div className="my-4 fs-6 d-flex flex-column gap-2">
              <Button onClick={() => setActivePage("nonBindingDispute")}>
                NON BINDING DISPUTE
              </Button>
              <Button onClick={() => setActivePage("trackNonBindingDispute")}>
                TRACK YOUR DISPUTE
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
);

const RaiseYourDispute = () => {
  const [activePage, setActivePage] = useState("homePage");
  const authUser = getAuthUserlocal(); // Get authenticated user data
  const membership = authUser.selectMembership;
  const arbitratorId = authUser._id; // Assuming _id is available in authUser for arbitrators

  // Titles for non-arbitrator pages
  const pageTitles = {
    homePage: "Raise Your Dispute",
    nonBindingDispute: "Raise Your Dispute / Non-Binding Dispute",
    bindingDispute: "Raise Your Dispute / Binding Dispute",
    trackBindingDispute: "Track AECCI-IAC Binding Dispute",
    trackNonBindingDispute: "Track Non Binding Dispute",
    caseSummery: "Raise Your Dispute / Case Summary",
  };

  // Components for non-arbitrator pages
  const pageComponents = {
    homePage: <HomePage setActivePage={setActivePage} />,
    nonBindingDispute: <NonBindingDispute setActivePage={setActivePage} />,
    bindingDispute: <BindingDispute setActivePage={setActivePage} />,
    bindingDisputeDetails: <BindingDisputeDetails setActivePage={setActivePage} />,
    trackNonBindingDispute: (
      <NonBindingDisputeTrack setActivePage={setActivePage} />
    ),
    trackBindingDispute: (
      <BindingDisputeTrack setActivePage={setActivePage} />
    ),
    caseSummery: <NonBindingCaseSummery setActivePage={setActivePage} />,
  };

  // Title logic: Use "Arbitrator Dashboard" for arbitrators, otherwise use pageTitles
  const title =
    membership === "Arbitration"
      ? "AECCI-IAC Binding Dispute Dashboard"
      : pageTitles[activePage] || "Raise Your Dispute";

  // Content logic: Show ArbitratorDisputesPage for arbitrators, otherwise show pageComponents
  const content =
    membership === "Arbitration" ? (
      <div className="p-1">
        <ArbitratorDisputesPage arbitratorId={arbitratorId} />
      </div>
    ) : (
      pageComponents[activePage] || <div>Something went wrong!!!</div>
    );

  return (
    <Layout>
      <Layout2>
        <DashboardHeader />
        <h4 className="pt-4 mb-3">{title}</h4>
        <hr />
        {content}
        <QuickLinks />
      </Layout2>
    </Layout>
  );
};

export default RaiseYourDispute;